export default __webpack_public_path__ + "static/media/cshare-avax.de65fbd0.png";